// components/ui/Input.jsx
// Created: 2026-07-20
// Project: Giving Words to Voices
// Version: 1.0.0
//
// The Input primitive — text field and textarea. Nearly every input in the app
// was authored with the same six declarations (inputBg / text / border /
// radius / boxSizing / outline:none), copied inline. Two problems it fixes:
//   1. one shape, read from the theme, so a field is always the scheme's colour
//   2. it does NOT set outline:none. Every inline input suppressed the outline,
//      which is why keyboard focus was invisible on forms. Dropping the
//      suppression lets the global :focus-visible ring (index.css) show through.
// Set multiline for a textarea. invalid switches the border to the danger colour.

import React from 'react';
import { RADIUS } from '../../constants/tokens';
import { DANGER } from '../../constants/palette';

const FONT = { sm: '0.75rem', md: '0.82rem', lg: '0.95rem' };

export default function Input({
  multiline = false,
  size = 'md',
  invalid = false,
  fullWidth = true,
  rows = 3,
  style = {},
  ...rest
}) {
  // theme passed by prop, as everywhere in the app.
  const theme = rest.theme || {};
  delete rest.theme;

  const Tag = multiline ? 'textarea' : 'input';
  const extra = multiline ? { rows, resize: 'vertical' } : {};

  return (
    <Tag
      {...(multiline ? { rows } : {})}
      style={{
        width: fullWidth ? '100%' : undefined,
        padding: '7px 9px',
        background: theme.inputBg || theme.card,
        color: theme.text,
        border: `1px solid ${invalid ? (theme.danger || DANGER) : theme.border}`,
        borderRadius: RADIUS.md,
        fontSize: FONT[size] || FONT.md,
        fontFamily: 'inherit',
        boxSizing: 'border-box',
        ...(multiline ? { resize: 'vertical' } : {}),
        ...style,
      }}
      {...rest}
    />
  );
}
